<template>
  <main><div class="page-heading"><div><p class="label">CONTENT</p><h2>统一内容库</h2></div></div><section class="panel"><p>普通影视、受限影视、短视频、帖子、小说和图集将通过内容分区统一管理。Go 管理 API 接通前此页保持只读占位。</p></section></main>
</template>

